/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
//import translation function for language translation
import { useTranslation } from 'react-i18next';

//import context
import { GlobalProvider } from 'context/GlobalContext';

const CostTemplateHeader = ({
  setDownloadExcel,
  records,
  setSearch,
  blockRefSelected,
}) => {
  const { t } = useTranslation(); //for translation

  const { setReloadCostList, setSuccess, setNotificationString } =
    useContext(GlobalProvider);

  /* hook to get the search value */
  const [searchValue, setSearchValue] = useState('');
  /* hook to control info accordion visibility */
  const [showInfo, setShowInfo] = useState(false);
  /* function to click download xls*/
  const handleDownloadClick = () => {
    setDownloadExcel(true);

    setTimeout(() => setDownloadExcel(false), 500);
  };
  /* hook to empty search when searchValue gets empty */
  useEffect(() => {
    !searchValue && setSearch('');
  }, [searchValue]);

  return (
    <>
      <div className="filter-container d-flex flex-wrap align-items-center gap-2 pb-1 ">
        {/* <Link
          to="#columnCollapse"
          className="column-collapse btn btn-primary icon-btn mw-unset"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="columnCollapse"
        >
          <span className="d-block material-symbols-outlined icon-fill">
            visibility
          </span>
        </Link> */}
        <Link
          to="#"
          onClick={handleDownloadClick}
          className="download btn btn-primary icon-btn mw-unset"
        >
          <span className="d-block material-symbols-outlined">download</span>
        </Link>
        <div className="search-container position-relative d-none d-md-block">
          {/* <form action="">
            <input
              type="search"
              placeholder={t('Search here')}
              className="form-control bg-transparent py-2 border-0"
              onChange={e => setSearchValue(e.target.value)}
              onKeyDown={e => {
                e.key === 'Enter' &&
                  (e.preventDefault(), setSearch(searchValue));
              }}
            />
            <button
              onClick={() => setSearch(searchValue)}
              type="button"
              className="bg-transparent text-dark p-0 border-0 position-absolute top-50 translate-middle-y"
            >
              <span className="d-block material-symbols-outlined">search</span>
            </button>
          </form> */}
        </div>
        {/* ------------- showing records start ----------------- */}
        <p className="text-gray fw-medium ms-auto me-3">
          {t('Showing')}
          <span className="text-black ms-1">{records}</span> {t('Records')} -
          <span className="text-black ms-1" ref={blockRefSelected}>
            {' '}
            0{' '}
          </span>{' '}
          {t('Selected')}
        </p>
        {/* ------------- showing records end ----------------- */}
        {/* ----- refresh icon start ------ */}
        <Link
          to="#"
          className="filter-btn btn btn-primary icon-btn mw-unset"
          onClick={() => {
            setReloadCostList(true);
            setSuccess(true);
            setNotificationString(
              t('The list has been refreshed successfully')
            );
          }}
        >
          <span className="d-block material-symbols-outlined">refresh</span>
        </Link>
        {/* ----- refresh icon end ------ */}
        <Link
          to="#filterCollapse"
          className="filter-btn btn btn-primary icon-btn mw-unset "
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="filterCollapse"
        >
          <span className="d-block material-symbols-outlined">filter_alt</span>
        </Link>
        {/* ----- info icon start ------ */}
        <Link
          to="#"
          className="info-btn btn btn-outline-primary icon-btn mw-unset"
          onClick={(e) => {
            e.preventDefault();
            setShowInfo(!showInfo);
          }}
          title={t('Cost Calculation Information')}
        >
          <span className="d-block material-symbols-outlined">info</span>
        </Link>
        {/* ----- info icon end ------ */}
      </div>

      {/* ----- Cost Calculation Info Accordion start ------ */}
      {showInfo && (
        <div className="cost-info-accordion mb-3 mt-2">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-0">
              <div className="accordion" id="costCalculationAccordion">
                {/* Overview Section */}
                <div className="accordion-item border-0">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button bg-light"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#overviewCollapse"
                      aria-expanded="true"
                      aria-controls="overviewCollapse"
                    >
                      <span className="material-symbols-outlined me-2 text-primary">
                        calculate
                      </span>
                      <strong>{t('Cost Calculation Overview')}</strong>
                    </button>
                  </h2>
                  <div
                    id="overviewCollapse"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#costCalculationAccordion"
                  >
                    <div className="accordion-body">
                      <p className="mb-2">
                        <strong>{t('Total Cost')} = </strong>
                        {t('Activity Time')} + {t('Preparation Time')} + {t('Mounting Time')} + 
                        {t('Dismantle Time')} + {t('Arrival Time')} + {t('Return Time')} + {t('Gap Time')}
                      </p>
                      <p className="text-muted small mb-0">
                        {t('The system automatically calculates costs for each educator based on their scheduled events and applies optimization rules to avoid double-billing.')}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Exception 1 and 2 */}
                <div className="accordion-item border-0 border-top">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed bg-light"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#exception1Collapse"
                      aria-expanded="false"
                      aria-controls="exception1Collapse"
                    >
                      <span className="material-symbols-outlined me-2 text-success">
                        check_circle
                      </span>
                      <strong>{t('Exception 1 & 2: Travel Time Adjustments')}</strong>
                    </button>
                  </h2>
                  <div
                    id="exception1Collapse"
                    className="accordion-collapse collapse"
                    data-bs-parent="#costCalculationAccordion"
                  >
                    <div className="accordion-body">
                      <p className="mb-3">
                        {t('For consecutive events, travel times are optimized to avoid double-billing since the educator remains at the location:')}
                      </p>
                      
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="bg-light p-3 rounded h-100">
                            <h6 className="text-success mb-2">
                              <span className="material-symbols-outlined align-middle me-1" style={{fontSize: '16px'}}>
                                arrow_back
                              </span>
                              {t('Exception 1: Remove Return Travel of First Event')}
                            </h6>
                            <p className="small mb-2">
                              {t('The return travel time from the first event is removed.')}
                            </p>
                            <code className="small d-block">Return Time = 0</code>
                            <code className="small d-block">Office Return Time = 0</code>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="bg-light p-3 rounded h-100">
                            <h6 className="text-success mb-2">
                              <span className="material-symbols-outlined align-middle me-1" style={{fontSize: '16px'}}>
                                arrow_forward
                              </span>
                              {t('Exception 2: Remove Arrival Travel of Consecutive Event')}
                            </h6>
                            <p className="small mb-2">
                              {t('The arrival travel time to the second event is removed.')}
                            </p>
                            <code className="small d-block">Arrival Time = 0</code>
                            <code className="small d-block">Office Arrival Time = 0</code>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Exception 3 */}
                <div className="accordion-item border-0 border-top">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed bg-light"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#exception3Collapse"
                      aria-expanded="false"
                      aria-controls="exception3Collapse"
                    >
                      <span className="material-symbols-outlined me-2 text-warning">
                        sync_alt
                      </span>
                      <strong>{t('Exception 3: Shift Change Adjustment')}</strong>
                    </button>
                  </h2>
                  <div
                    id="exception3Collapse"
                    className="accordion-collapse collapse"
                    data-bs-parent="#costCalculationAccordion"
                  >
                    <div className="accordion-body">
                      <p className="mb-2">
                        {t('When consecutive events are in different shifts (morning/evening), setup/teardown times are re-added:')}
                      </p>
                      <ul className="small mb-2">
                        <li>{t('Re-add dismantle time to the first event')}</li>
                        <li>{t('Re-add mounting time to the second event (NOT preparation - that was done earlier)')}</li>
                      </ul>
                      <p className="text-muted small mb-0">
                        {t('This accounts for the educator needing to pack up and physically set up equipment again across different shifts.')}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Exception 4 - Gap Time */}
                <div className="accordion-item border-0 border-top">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed bg-light"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#exception4Collapse"
                      aria-expanded="false"
                      aria-controls="exception4Collapse"
                    >
                      <span className="material-symbols-outlined me-2 text-info">
                        schedule
                      </span>
                      <strong>{t('Exception 4: Gap Time Calculation')}</strong>
                    </button>
                  </h2>
                  <div
                    id="exception4Collapse"
                    className="accordion-collapse collapse"
                    data-bs-parent="#costCalculationAccordion"
                  >
                    <div className="accordion-body">
                      <p className="mb-3">
                        {t('Billable gap time between consecutive events is calculated based on three scenarios:')}
                      </p>
                      
                      <div className="mb-3">
                        <h6 className="text-success">
                          <span className="material-symbols-outlined align-middle me-1" style={{fontSize: '18px'}}>
                            check_circle
                          </span>
                          {t('Case 1: Same Shift')}
                        </h6>
                        <p className="small mb-1">{t('Full gap time is billable.')}</p>
                        <div className="bg-light p-2 rounded">
                          <code className="small">Gap Time = Difference in end time of previous event and start time of next event</code>
                        </div>
                      </div>

                      <div className="mb-3">
                        <h6 className="text-info">
                          <span className="material-symbols-outlined align-middle me-1" style={{fontSize: '18px'}}>
                            home
                          </span>
                          {t('Case 2: Different Shift - Can Go Home')}
                        </h6>
                        <p className="small mb-1">
                          {t('If time gap between events is ≥ (2 × Travel Time) + 60 min, educator can go home. Travel and setup times are re-added:')}
                        </p>
                        <div className="bg-light p-2 rounded mb-2">
                          <div className="small mb-1"><strong>{t('Previous Event:')}</strong></div>
                          <code className="small d-block">+ Office Return Time</code>
                          <code className="small d-block">+ Home Return Time</code>
                        </div>
                        <div className="bg-light p-2 rounded">
                          <div className="small mb-1"><strong>{t('Next Event:')}</strong></div>
                          <code className="small d-block">+ Office Arrival Time from Home</code>
                          <code className="small d-block">+ Location Arrival Time from Office</code>
                          <code className="small d-block">+ Mounting Time (setup again)</code>
                        </div>
                      </div>

                      <div className="mb-0">
                        <h6 className="text-warning">
                          <span className="material-symbols-outlined align-middle me-1" style={{fontSize: '18px'}}>
                            lunch_dining
                          </span>
                          {t('Case 3: Different Shift - Cannot Go Home')}
                        </h6>
                        <p className="small mb-1">
                          {t('If gap < (2 × Travel Time) + 60 min, educator cannot go home. Bill gap minus 1-hour lunch.')}
                        </p>
                     
                        <div className="bg-light p-2 rounded mb-2">
                          <div className="small mb-1"><strong>{t('Previous Event:')}</strong></div>
                          <code className="small">+ Dismantle Time to previous event</code>
                          <code className="small d-block">+ Gap Time between events</code>
                        </div>
                        <div className="bg-light p-2 rounded">
                          <div className="small mb-1"><strong>{t('Next Event:')}</strong></div>
                          <code className="small">+ Dismantle Time to previous event</code>
                          <code className="small d-block">+ Mounting Time (setup again)</code>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

           
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ----- Cost Calculation Info Accordion end ------ */}
    </>
  );
};

export default CostTemplateHeader;
